<script>
  import { Doughnut, mixins } from 'vue-chartjs';

  const { reactiveProp } = mixins;

  export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    data() {
      return {
        chartOptions: {
          cutoutPercentage: 80,
          legend: {
            display: false,
          },
          elements: {
            arc: {
              borderWidth: 0,
            },
          },
          tooltips: {
            enabled: false,
          },
        },
      };
    },
    mounted() {
      this.renderChart(this.chartData, this.chartOptions);
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/classes/components/DoughnutChart.vue